<template lang="pug">
  include /mixins
  +b.image-clipper
    +e.title.P {{ _("Настройка фотографии") }}
    +b.g-row.--space_lg.--appearance_spaced
      +b.g-cell.g-cols--12
        +b.g-row.--space_lg.--appearance_spaced
          +b.g-cell.g-cols--6
            image-clipper-basic(
              ref="clipper"
              :src="imgURL"
              class="my-clipper"
              :rotate='rotate'
              preview='my-preview'
              :ratio='ratio'
              :scale='scale'
              :wrap-ratio='1'
              :initial='{ w, h }'
              :round='round'
            )
              div(
                v-bem:image-clipper.no-image=''
                slot="placeholder"
              ) {{ _('Изображение не загружено') }}

          +b.g-cell.g-cols--6
            my-preview.my-clipper(
              name="my-preview"
              :class="[`rate${rate}`, { 'is-horizontal': orientation === 'horizontal', 'is-vertical': orientation === 'vertical' }]"
            )

      +b.g-cell.g-cols--12
        +b.clipper-info
          +e.item.--variant_desktop
            +b.clipper-desc
              +e.item
                +b.ds-caption--size_3xs.P {{ _('* Удерживайте левую кнопку мыши и передвигайте курсор, чтобы выбрать подходящий участок изображения, либо воспользуйтесь ползунком справа') }}
              +e.item
                +b.ds-caption--size_3xs.P {{ _('** Воспользуйтесь колесиком мышки, чтобы выбрать маштаб изображения, либо воспользуйтесь ползунком справа') }}
          +e.item
            +b.clipper-desc
              +b.ds-caption--size_xs.P {{ _('Move to change the rotation angle:') }}
              clipper-range(
                v-model='rotate'
                :max='360'
              )
              +b.ds-caption--size_xs.P {{ _('Move to change a scale value:') }}
              clipper-range(
                v-model='scale'
                :max='2'
                :min='0.1'
              )

      +b.g-cell.g-cols--12
        +b.g-row--appearance_spaced
          +b.g-cell.g-cols--6
            +b.tt-button--bordered_main.--auto.CLIPPER-UPLOAD(
              v-model="imgURL"
            )
              +e.title.P {{ _('Выбрать новое') }}
          +b.g-cell.g-cols--6
            +b.g-row.--justify_end
              +b.g-cell
                +b.tt-button.--auto.A(
                  href=''
                  v-if='imgURL'
                  @click.prevent='crop'
                )
                  +e.title.P {{ _('Сохранить') }}
    +b.close-popup.A(
      href='',
      @click.prevent='$emit("close")',
      :key='2'
    )
      +e.icon.mdi.mdi-close
</template>

<script>

export default {
  props: {
    preview: {},
    promise: {},
    ratio: {},
    rate: {},
    w: {},
    h: {},
    round: {
      default: () => false,
    },
    orientation: {
      type: String,
    },
  },
  name: 'ImageClipper',
  data() {
    return {
      imgURL: this.preview,
      rotate: 0,
      scale: 1,
    }
  },
  watch: {
    scale(val) {
      this.$refs.clipper.setWH$.next(val)
    },
  },
  mounted() {
    this.$refs.clipper.onChange$.subscribe(() => {
      // This happens whenever zooming, moving and rotating occur.
    })
  },
  methods: {
    crop() {
      const canvas = this.$refs.clipper.clip()
      console.log(canvas);
      const dataURL = canvas.toDataURL()
      const blobBin = atob(dataURL.split(',')[1])
      const array = []
      for (let i = 0; i < blobBin.length; i++) {
        array.push(blobBin.charCodeAt(i))
      }
      const file = new Blob([new Uint8Array(array)], { type: 'image/png' })
      const newFile = new File([file], 'name.png', { type: 'image/png' })
      this.promise(newFile)
      this.$emit('close')
    },
  },
}
</script>
